import { DefaultListParams } from '../types/DefaultListParams';

export const defaultListParams: DefaultListParams = {
  page: 0,
  pageSize: 20,
};
